<template>
  <div class="dialog-root" v-loading="loading">
    <div class="container">
      <avue-form ref="formRef" :option="formOption" v-model="formData">
        <template slot="alarmBalance">
          <moneyInput
            v-model="formData.alarmBalance"
            placeholder="请输入 余额预警值"
            :disabled="dialogType == 'view'"
            style="width: 100%"
          />
        </template>
      </avue-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder" v-if="dialogType != 'view'"></div>
    <!-- 底部操作按钮 -->
    <div class="btn" v-if="dialogType != 'view'">
      <el-button type="primary" size="small" @click="doSave">
        {{ dialogType == 'edit' ? '修改' : '保存' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getAreaList } from '@/api/meter-management/meter-permission';
import { getDict, getDetail, add, update } from '@/api/meter-management/index';

export default {
  props: ['dialogType', 'areaCode', 'rowData'],
  data() {
    return {
      loading: false,
      dicDatas: {
        areaCode: [],
        meterType: [],
        meterCategory: [],
      },
      formData: {
        prepayFlag: '',
      },
    };
  },
  computed: {
    formOption() {
      return {
        labelWidth: 110,
        menuBtn: false,
        column: [
          {
            label: '仪表表号',
            prop: 'code',
            span: 8,
            disabled: this.dialogType == 'view',
            maxlength: 30,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入仪表表号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '仪表名称',
            prop: 'name',
            span: 8,
            disabled: this.dialogType == 'view',
            maxlength: 30,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入仪表名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '管理区域',
            prop: 'areaCode',
            span: 8,
            disabled: this.dialogType == 'view' || this.formData.meterCategory == 'INCOME_METER',
            dicData: this.dicDatas.areaCode,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            type: 'tree',
            rules: [
              {
                required: true,
                message: '请选择管理区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '期初起码',
            prop: 'initStartNum',
            value: 0,
            span: 8,
            disabled: this.dialogType == 'view',
            maxlength: 30,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入期初起码',
                trigger: 'blur',
              },
              {
                pattern: /^-?\d+(\.\d+)?$/,
                message: '请输入数字',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '仪表类别',
            prop: 'meterCategory',
            span: 8,
            disabled: true,
            type: 'select',
            dicData: this.dicDatas.meterCategory,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择仪表类别',
                trigger: 'change',
              },
            ],
          },
          {
            label: '上级仪表',
            prop: 'parentName',
            span: 8,
            disabled: true,
            display: this.formData.meterCategory == 'INCOME_METER',
          },
          {
            label: '仪表类型',
            prop: 'meterType',
            span: 8,
            disabled: this.dialogType == 'view' || this.formData.meterCategory == 'INCOME_METER',
            type: 'select',
            dicData: this.dicDatas.meterType,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择仪表类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '预充值表',
            prop: 'prepayFlag',
            span: 8,
            disabled: this.dialogType == 'view',
            display: this.formData.meterCategory == 'INCOME_METER',
            type: 'radio',
            dicData: [
              { label: '是', value: 'YES' },
              { label: '否', value: 'NO' },
            ],
          },
          {
            label: '预充值表余额',
            prop: 'balance',
            value: 0,
            span: 8,
            disabled: true,
            display:
              this.formData.meterCategory == 'INCOME_METER' && this.formData.prepayFlag == 'YES',
          },
          {
            label: '余额预警值',
            prop: 'alarmBalance',
            value: 0,
            span: 8,
            formslot: true,
            display:
              this.formData.meterCategory == 'INCOME_METER' && this.formData.prepayFlag == 'YES',
            rules: [
              {
                required: true,
                message: '请输入余额预警值',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '表倍率',
            prop: 'multiplier',
            value: 1,
            span: 8,
            disabled: this.dialogType == 'view',
            maxlength: 9,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入预充值表余额',
                trigger: 'blur',
              },
              {
                pattern: /^[1-9]\d{0,8}$/,
                message: '请输入正整数',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '仪表型号',
            prop: 'meterModel',
            span: 8,
            disabled: this.dialogType == 'view',
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '仪表品牌',
            prop: 'meterBrand',
            span: 8,
            disabled: this.dialogType == 'view',
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '安装日期',
            prop: 'installDate',
            span: 8,
            disabled: this.dialogType == 'view',
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '安装位置',
            prop: 'installAddr',
            span: 16,
            disabled: this.dialogType == 'view',
            maxlength: 100,
            showWordLimit: true,
          },
          {
            label: '计量范围',
            prop: 'measureRange',
            span: 24,
            disabled: this.dialogType == 'view',
            maxlength: 200,
            showWordLimit: true,
          },
          {
            label: '辅助字段',
            prop: 'auxField',
            span: 24,
            disabled: this.dialogType == 'view',
            maxlength: 200,
            showWordLimit: true,
          },
          {
            label: '备注',
            prop: 'description',
            span: 24,
            disabled: this.dialogType == 'view',
            type: 'textarea',
            minRows: 2,
            maxlength: 500,
            showWordLimit: true,
          },
        ],
      };
    },
  },
  async created() {
    // 因为表单的配置选项使用的是计算属性，如果是使用dicUrl则每次重新生成值都会触发字典加载，所以这里使用dicData
    await Promise.all([
      getAreaList(),
      getDict({ code: 'shunt_meter_type' }),
      getDict({ code: 'shunt_meter_category' }),
    ]).then((res) => {
      this.dicDatas.areaCode = res[0].data;
      this.dicDatas.meterType = res[1].data;
      this.dicDatas.meterCategory = res[2].data;
    });
    if (this.dialogType === 'edit' || this.dialogType === 'view') {
      this.getDetail();
    } else {
      if (this.dialogType == 'add') {
        this.formData = {
          meterCategory: 'EXPEND_METER',
          meterType: this.dicDatas.meterType[0].dictKey,
          areaCode: this.areaCode,
          parentName: '无',
        };
      } else if (this.dialogType == 'addChild') {
        this.formData = {
          parentId: this.rowData.id,
          meterCategory: 'INCOME_METER',
          meterType: this.rowData.meterType,
          areaCode: this.rowData.areaCode,
          parentName: this.rowData.name,
          prepayFlag: 'YES',
        };
      }
    }
  },
  methods: {
    /* 获取详情 */
    getDetail() {
      this.loading = true;
      getDetail({
        id: this.rowData.id,
      })
        .then(({ data }) => {
          this.formData = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /* 保存 */
    doSave() {
      this.$refs.formRef.validate(async (valid) => {
        this.$refs.formRef.allDisabled = false; // avue-form表单验证后会导致表单项禁止编辑，需要重置此属性解除这个限制
        if (valid) {
          // 如果修改了支出表的仪表类型，需要用户额外确认
          if (
            this.dialogType == 'edit' &&
            this.formData.meterCategory == 'EXPEND_METER' &&
            this.rowData.meterType != this.formData.meterType
          ) {
            await this.$confirm('是否修改支出表和收入表的仪表类型？', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning',
            })
              .then(() => {})
              .catch(() => {
                this.formData.meterType = this.rowData.meterType;
              });
          }
          let fn = this.dialogType == 'edit' ? update : add;
          fn(this.formData, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
